export default __webpack_public_path__ + "static/media/overview-icon.0f905784.svg";